import styled from 'styled-components';

export const LoaderWrapper = styled.div`
  display: grid;
  height: 100%;
  place-items: center center;
`;
